import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';import { DomSanitizer } from '@angular/platform-browser';
import { ObspointActionHistroyComponent } from '../equipment-details/components/obspoint-action-histroy/obspoint-action-histroy.component';
import { ComponentObservationPointDetails, ObspointActionHistroy, SchematicAndObservationPointDetails, SchematicDetails } from '../equipment-details/equipment-details.model';

@Component({
  selector: 'app-implement-details-history',
  templateUrl: './implement-details-history.component.html',
  styleUrls: ['./implement-details-history.component.scss'],
  animations: [
    trigger(
      'fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('500ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 0 }),
        animate('0ms', style({ opacity: 0 }))
      ])
    ]
    )]
})
export class ImplementDetailsHistoryComponent implements OnInit {

  @Input() SchematicAndObservationPoints: SchematicAndObservationPointDetails = new SchematicAndObservationPointDetails();
  @Input() cusID: number;
  @Input() SMU: number;
  @Input() ImplementId: number;

  @Output() updateObs: EventEmitter<boolean> = new EventEmitter();

  oldGETUri: string;
  ObservationPointDetails: ComponentObservationPointDetails[]=[];
  //headerAction:ComponentObservationPointDetails;
  headerAction:ObspointActionHistroy[]=[];
  schematicDetails: SchematicDetails;
  actionRendered: boolean = false;
  constructor(private _sanitizer: DomSanitizer, private _dialog: MatDialog,
  ) { }

  ngOnInit() {
    //console.log("input data__", this.SchematicAndObservationPoints)
    this.ObservationPointDetails = this.SchematicAndObservationPoints.ObservationPoints;
    this.schematicDetails = this.SchematicAndObservationPoints.Schematic;
    //this.headerAction = this.ObservationPointDetails.length>0?this.ObservationPointDetails[0] :null;
    this.headerAction = this.SchematicAndObservationPoints.ObservationPointsHeader;
  }

  sanitize(image: string) {

    //return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
  }
  getCrackStatus(IsFixed: boolean) {
    if (IsFixed == true) {
      return " WornPctCellCrack evalColorA";
    }
    else {
      return " WornPctCellCrack evalColorX";
    }

  }

  getEvalClass(wornPct: number) {
    if (wornPct <= 30) {
      return " WornPctCell evalColorA";
    }
    else if ((wornPct > 30) && (wornPct <= 60)) {
      return " WornPctCell evalColorB";
    }
    else if ((wornPct > 60) && (wornPct <= 80)) {
      return " WornPctCell evalColorC";
    }
    else if (wornPct > 80) {
      return "WornPctCell evalColorX";
    }

    return " WornPctCell noEval";
  }

  getEvalClass2(evalCode: string) {
    if (evalCode == "A") {
      return " WornPctCell evalColorA";
    }
    else if (evalCode == "B") {
      return " WornPctCell evalColorB";
    }
    else if (evalCode == "C") {
      return " WornPctCell evalColorC";
    }
    else if (evalCode == "X") {
      return "WornPctCell evalColorX";
    }

    return " WornPctCell noEval";
  }


  OpenNormalObsHistroyDialog(OBPoint: ComponentObservationPointDetails) {
    //console.log("open crack statu", OBPoint)

    if (OBPoint.ObPointTypeId !== 2) {
      //console.log("open crack statu__", OBPoint)
      let inspectionPlannerDialog = this._dialog.open(ObspointActionHistroyComponent, {
        panelClass: 'removeModalOverflow',
        disableClose: true,
        data: {
          obId: OBPoint.Id,
          CompName: OBPoint.ComponentName,
          ObsName: OBPoint.Name,
          componentId: OBPoint.ComponentId,
          isCrack:false,
        },

      });

      inspectionPlannerDialog.afterClosed().subscribe(result => {

        if (result == true) {
          this.updateObs.emit(true);
          //this.loadEquipmentDetails();
        }
      });
    }
    if (OBPoint.ObPointTypeId === 2) {
      let openRemoveImplementModalRef = this._dialog.open(ObspointActionHistroyComponent, {
        panelClass: 'removeModalOverflow',
        disableClose: true,
        data: {
          obId: OBPoint.Id,
          CompName: OBPoint.ComponentName,
          ObsName: OBPoint.Name,
          componentId: OBPoint.ComponentId,
          isCrack:true,
        }
      });
      openRemoveImplementModalRef.afterClosed().subscribe((result) => {

        if (result == true) {
          this.updateObs.emit(true);
        }
      });
    }

  }

  OpenReplaceRepairAction(item:ObspointActionHistroy){
    let inspectionPlannerDialog = this._dialog.open(ObspointActionHistroyComponent, {
      panelClass: 'removeModalOverflow',
      disableClose: true,
      data: {
        GETEventId: item.GETEventId,
        implementId: this.ImplementId,
      },

    });

    inspectionPlannerDialog.afterClosed().subscribe(result => {

      if (result == true) {
        this.updateObs.emit(true);
        //this.loadEquipmentDetails();
      }
    });
  }

}
